import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import AnimateHeight from 'react-animate-height';
import './CheckoutAlert.scss';

export default function CheckoutAlert({ message = { title: '', text: '', type: '' } }) {
  const [displayAlertHeight, setDisplayAlertHeight] = useState(0);
  const [messageTitle, setMessageTitle] = useState('');
  const [messageBody, setMessageBody] = useState('');
  const [messageType, setMessageType] = useState('error');
  const dropdownAnimationTime = 500; // ms

  useEffect(() => {
    const { title, text, type } = message;

    if (title === '' && text === '') { // Hiding dropdown...
      setDisplayAlertHeight(0);
      setTimeout(() => {
        setMessageTitle(title);
        setMessageBody(text);
        if (type.length > 0) setMessageType(type);
      }, dropdownAnimationTime);
    } else { // Showing dropdown...
      if (title.length > 0) setMessageTitle(title);
      if (text.length > 0) setMessageBody(text);
      if (type.length > 0) setMessageType(type);
      setDisplayAlertHeight('auto');
    }
  }, [message]);

  return (
    <AnimateHeight
      className="CheckoutAlert"
      duration={dropdownAnimationTime}
      height={displayAlertHeight}
    >
      <Alert
        showIcon
        className="lead-follow-imbalance-alert"
        message={messageTitle}
        description={messageBody}
        type={messageType.length > 0 ? messageType : 'error'}
      />
    </AnimateHeight>
  )
}
